<div class="flex flex-col gap-4">
  <div class="flex items-center gap-2">
    <div class="flex-1 flex justify-center md:justify-between items-center">
      <span class="text-[#222528] text-[1.1875rem] md:text-[1.375rem] font-bold">{{
        'dashboard.activeMissions' | translate
      }}</span>
      <a
        data-testid="active-missions-view-all"
        routerLink="/workspace/promotions/missions"
        class="hidden gap-[0.5rem] items-center no-underline md:flex"
      >
        <span class="font-light text-[1.125rem] leading-[1.6] text-[#007dcb]">
          {{ 'promotions.viewAll' | translate }}
        </span>
        <img
          src="assets/img/dashboard-v2/view-all-chevron.svg"
          alt=""
          aria-hidden="true"
          class="size-6 shrink-0 rotate-180 object-scale-down"
        />
      </a>
    </div>
  </div>
  @if (isLoading()) {
    <div class="flex min-h-[9rem] items-center justify-center rounded-[0.5rem] bg-white" aria-live="polite">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (loadError()) {
    <div
      class="flex min-h-[9rem] flex-col items-center justify-center gap-3 rounded-[0.5rem] bg-white p-4 text-center"
      role="alert"
    >
      <p class="m-0 text-[0.9375rem] text-[#505760]">{{ 'promotions.missions.loadError' | translate }}</p>
      <button
        type="button"
        class="min-h-10 rounded-[0.375rem] border border-[#017f70] bg-[#017f70] px-4 text-[#fcfcfc]"
        (click)="loadActiveCampaign()"
      >
        {{ 'promotions.missions.retry' | translate }}
      </button>
    </div>
  } @else if (activeCampaign(); as campaign) {
    <a
      data-testid="active-mission-card-link"
      routerLink="/workspace/promotions/missions"
      class="bg-white box-border flex gap-[0.5rem] items-center p-[1rem] rounded-[0.5rem] shadow-[0px_5px_15px_0px_rgba(138,142,148,0.1)] w-full no-underline"
    >
      <div class="basis-0 flex flex-col gap-[1rem] grow items-start justify-center min-h-px min-w-px">
        <div class="flex gap-[1rem] items-center w-full">
          <div class="basis-0 flex gap-[1rem] grow items-center min-h-px min-w-px">
            <div class="shrink-0 size-[3.5rem] md:size-[3.5rem] relative">
              <img
                [src]="campaign.image || 'assets/img/missions/mission-icon.svg'"
                [alt]="campaign.image ? campaign.name : ''"
                [attr.aria-hidden]="campaign.image ? null : 'true'"
                class="block max-w-none size-full object-cover rounded-[0.5rem]"
              />
            </div>

            <div class="basis-0 flex flex-col gap-[0.25rem] grow items-start leading-[1.6] min-h-px min-w-px">
              <p
                class="m-0 font-medium overflow-ellipsis overflow-hidden text-[1rem]/[160%] md:text-[1.125rem]/[160%] text-[#2C3035] text-nowrap w-full"
              >
                {{ campaign.name }}
              </p>
              <p class="m-0 font-normal text-[0.8125rem]/[160%] md:text-[0.9375rem]/[160%] text-[#505760] w-full">
                {{ campaign.description }}
              </p>
              <div class="flex flex-wrap gap-2">
                @if (campaign.category; as category) {
                  <span
                    class="inline-flex min-h-6 items-center rounded border border-[#93c8e9] bg-[#e6f2fa] px-2 py-0.5 text-[0.8125rem]/[160%] text-[#004a78]"
                  >
                    {{ category }}
                  </span>
                }
                @if (campaign.reward; as reward) {
                  <span
                    class="inline-flex min-h-6 items-center rounded border border-[#8ac4bd] bg-[#e6f2f1] px-2 py-0.5 text-[0.8125rem]/[160%] text-[#00352f]"
                  >
                    @if (reward.value) {
                      {{ reward.value }}
                    }
                    {{ 'promotions.campaignDetails.rewardTypes.' + reward.reward_type | translate }}
                  </span>
                }
              </div>
            </div>

            <span
              data-testid="active-mission-card-arrow"
              class="inline-flex size-5 shrink-0 items-center justify-center"
              aria-hidden="true"
            >
              <img
                src="assets/img/recent-activity/chevron-right.svg"
                alt=""
                class="h-[0.8125rem] w-[0.4375rem] scale-x-[-1]"
              />
            </span>
          </div>
        </div>

        @if (objectiveProgress(); as objectiveProgress) {
          <div class="flex flex-col gap-[0.5rem] items-center w-full">
            @if (objectiveProgress.target > 0) {
              <div class="w-full relative mb-2">
                <div class="absolute left-0 top-0 z-1 bg-[#E6F2F1] h-[0.75rem] rounded-[1.5rem] w-full"></div>
                <div
                  class="absolute left-0 top-0 z-2 bg-[#017F70] h-[0.75rem] rounded-[1.5rem]"
                  [style.width.%]="progress()"
                ></div>
              </div>
            }

            <div class="flex gap-[1rem] items-start justify-center w-full">
              <div class="basis-0 flex gap-[0.5rem] grow items-center justify-center min-h-px min-w-px">
                <p
                  class="m-0 basis-0 font-normal grow leading-[1.6] min-h-px min-w-px text-[0.8125rem] md:text-[0.9375rem] text-[#737980] text-center"
                >
                  {{
                    'promotions.missions.objectiveProgress'
                      | translate
                        : {
                            current: objectiveProgress.current,
                            target: objectiveProgress.target
                          }
                  }}
                </p>
              </div>
            </div>
          </div>
        }
      </div>
    </a>
  } @else {
    <div class="flex min-h-[9rem] items-center justify-center rounded-[0.5rem] bg-white p-4">
      <korviu-no-data size="medium" [message]="'promotions.missions.empty' | translate"></korviu-no-data>
    </div>
  }

  <a
    routerLink="/workspace/promotions/missions"
    class="md:hidden text-center text-[#007dcb] text-[0.9375rem] no-underline"
  >
    {{ 'promotions.viewAll' | translate }}
  </a>
</div>
